import { useEffect } from "react";
import backIcon from "../../assets/img/icons/back-svgrepo-com.svg";
import { useLocation, useNavigate } from "react-router-dom";

const BackButton = () => {
   const navigate = useNavigate();
   const location = useLocation();

   // Detect route changes (e.g., for resetting state)
   useEffect(() => {
      // console.log("Route changed:", location.pathname);
      // Perform logic based on the new route
   }, [location.pathname]);
   // Handle back button
   return (

      <button
         className="d-flex justify-content-center align-items-center back-btn me-2"
         onClick={() => {
            navigate(-1); // Go back to the previous route
         }}
      >
         <img src={backIcon} alt="backIcon" />
      </button>
   )


}
export default BackButton;